import type { ReactNode } from 'react';
import './shell.css';

// A full-height screen: fixed header region (passed as `header`) plus a
// scrollable content area that absorbs the safe-area at the bottom.
export function Screen({
  header,
  children,
  contentClassName,
}: {
  header?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
}) {
  return (
    <div className="screen">
      {header}
      <main className={`screen-body${contentClassName ? ` ${contentClassName}` : ''}`}>
        {children}
      </main>
    </div>
  );
}
